module.exports = __webpack_public_path__ + "img/aboutUsImg08.37905b64.png";